// extracted by css-extract-rspack-plugin
export default {"BorderedViewTitleHeader":"gIDtW","QueryBuilderViewHeaderContainer":"DzAmW"};